// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"headerIcon__DC8JL","header":"header__1V2Ql","block":"block__2YuOI","noteIcon":"noteIcon__3SYhN","tooltip":"tooltip__1L98K"};